import getCardTypeFromBrand from '../../utils/getCardTypeFromBrand';

/*

    {
      "addOption": {
        "type": "CREDIT",
        "creditCardType": "MC",
        "creditCardNumber": "5231535209686935",
        "expirationMonth": "4",
        "expirationYear": "2019",
        "clawback": "true"
      },
        "address": {
          "address1": "7060 Hollywood Blvd",
          "city": "Hollywood",
          "postalCode": "90027",
          "countryAbbreviation": "US",
          "stateAbbreviation": "CA",
          "unit": "S123",
          "firstName": "Tom",
          "lastName": "Jerry",
          "phone": "323000000"
        }
      }

*/

export default function populatePayoutCardForm(formData, data = {}) {
  const result = {
    ...formData,
  };

  populateFromDetails(result, data.details);
  populateFromAddress(result, data.address);

  result.onChangeValidate = {
    ...formData.onChangeValidate,
    expirationMonth: true,
    expirationYear: true,
    address1: true,
    city: true,
    countryAbbreviation: true,
    stateAbbreviation: true,
    unit: true,
    firstName: true,
    lastName: true,
    cardType: true,
    cardNumber: true,
    zipCode: true,
    phone: true,
  };

  result.valid = false;

  result.paymentOption = data;

  result.onChangeValidate = {
    ...formData.onChangeValidate,
    expirationMonth: true,
    expirationYear: true,
    address1: true,
    city: true,
    countryAbbreviation: true,
    stateAbbreviation: true,
    unit: true,
    firstName: true,
    lastName: true,
    cardType: true,
    cardNumber: true,
    zipCode: true,
    phone: true,
  };

  return result;
}

function populateFromAddress(formData, address) {
  if (!address) {
    return formData;
  }

  if (address.firstName) {
    formData.firstName = address.firstName; // eslint-disable-line no-param-reassign
  }

  if (address.lastName) {
    formData.lastName = address.lastName; // eslint-disable-line no-param-reassign
  }

  if (address.phone) {
    formData.phone = address.phone; // eslint-disable-line no-param-reassign
  }

  if (address.stateAbbreviation) {
    formData.stateAbbreviation = address.stateAbbreviation; // eslint-disable-line no-param-reassign
  }

  if (address.countryAbbreviation) {
    formData.countryAbbreviation = address.countryAbbreviation; // eslint-disable-line no-param-reassign
  }

  if (address.postalCode) {
    formData.zipCode = address.postalCode; // eslint-disable-line no-param-reassign
  }

  if (address.city) {
    formData.city = address.city; // eslint-disable-line no-param-reassign
  }

  if (address.unit) {
    formData.unit = address.unit; // eslint-disable-line no-param-reassign
  }

  if (address.address1) {
    formData.address1 = address.address1; // eslint-disable-line no-param-reassign
  }

  return formData;
}

function populateFromDetails(formData, details) {
  if (!details) {
    return formData;
  }

  if (details.type) {
    formData.type = details.type; // eslint-disable-line no-param-reassign
  }

  if (details.cardBrand) {
    formData.cardType = getCardTypeFromBrand(details.cardBrand); // eslint-disable-line no-param-reassign
  }

  if (details.lastFour) {
    formData.cardNumber = details.lastFour.toString(); // eslint-disable-line no-param-reassign
  }

  if (details.expirationMonth) {
    formData.expirationMonth = details.expirationMonth < 10 ? // eslint-disable-line no-param-reassign
      `0${details.expirationMonth}` : details.expirationMonth.toString();
  }

  if (details.expirationYear) {
    formData.expirationYear = details.expirationYear.toString(); // eslint-disable-line no-param-reassign
  }

  if (details.postalCode) {
    formData.postalCode = details.postalCode.toString(); // eslint-disable-line no-param-reassign
  }

  return formData;
}
